import type { NavCategory, NavSite } from "@/types/nav";

export const categories: NavCategory[] = [
  {
    id: "新闻资讯",
    name: "新闻资讯",
    icon: "ri-newspaper-line",
    description: "聚合主流门户、时政财经与地方新闻网站，第一时间掌握国内外重要资讯动态。",
    subCategories: ["综合新闻", "财经新闻", "地方新闻"],
  },
  {
    id: "电商购物",
    name: "电商购物",
    icon: "ri-shopping-bag-3-line",
    description: "收录综合电商、品牌特卖与生鲜食品平台，帮助用户快速比价、放心下单。",
    subCategories: ["综合电商", "品牌特卖", "生鲜食品"],
  },
  {
    id: "社交娱乐",
    name: "社交娱乐",
    icon: "ri-chat-smile-2-line",
    description: "涵盖社交平台、兴趣社区与内容分享站点，发现有趣的人和话题。",
    subCategories: ["社交平台", "兴趣社区", "内容分享"],
  },
  {
    id: "教育学习",
    name: "教育学习",
    icon: "ri-book-open-line",
    description: "汇集在线课程、公开课与考试学习资源，助力学生与职场人持续成长。",
    subCategories: ["在线课程", "公开课", "考试学习"],
  },
  {
    id: "工具软件",
    name: "工具软件",
    icon: "ri-tools-line",
    description: "精选云存储、效率办公与在线工具，让日常工作更省时省力。",
    subCategories: ["云存储", "效率办公", "在线工具"],
  },
  {
    id: "金融理财",
    name: "金融理财",
    icon: "ri-wallet-3-line",
    description: "覆盖股票行情、银行服务与支付理财入口，便捷查询与管理个人资产。",
    subCategories: ["股票行情", "银行服务", "支付理财"],
  },
  {
    id: "生活服务",
    name: "生活服务",
    icon: "ri-home-smile-line",
    description: "本地生活、分类信息与实用查询一站直达，解决日常琐碎需求。",
    subCategories: ["本地生活", "分类信息", "实用查询"],
  },
  {
    id: "视频音乐",
    name: "视频音乐",
    icon: "ri-movie-line",
    description: "集中视频平台、音乐电台与直播入口，休闲时光随时开启。",
    subCategories: ["视频平台", "音乐电台", "直播互动"],
  },
  {
    id: "科技数码",
    name: "科技数码",
    icon: "ri-cpu-line",
    description: "数码资讯、评测导购与效率数码资讯站点，选购新装备前先看这里。",
    subCategories: ["数码资讯", "评测导购", "行业观察"],
  },
  {
    id: "招聘求职",
    name: "招聘求职",
    icon: "ri-briefcase-line",
    description: "综合招聘、互联网招聘与兼职实习平台，帮求职者高效找到合适岗位。",
    subCategories: ["综合招聘", "互联网招聘", "兼职实习"],
  },
  {
    id: "旅游出行",
    name: "旅游出行",
    icon: "ri-flight-takeoff-line",
    description: "机票酒店、攻略社区与交通出行服务，规划一场说走就走的旅行。",
    subCategories: ["机票酒店", "攻略社区", "交通出行"],
  },
  {
    id: "编程开发",
    name: "编程开发",
    icon: "ri-code-s-slash-line",
    description: "代码托管、技术社区与开源项目资源，开发者日常提升必备。",
    subCategories: ["代码托管", "技术社区", "开源项目"],
  },
];

export const sites: NavSite[] = [
  // 新闻资讯
  {
    id: "people",
    name: "人民网",
    url: "https://www.people.com.cn",
    description: "权威时政新闻门户，聚焦国内外重大事件与政策解读。",
    detail: "人民网是综合性权威新闻门户，涵盖时政、经济、国际、社会等多个频道。网站内容严谨、更新及时，适合希望快速了解国内外重大新闻的用户浏览。建议关注首页头条与专题栏目，获取深度报道与权威评论。",
    categoryId: "新闻资讯",
    subCategory: "综合新闻",
    tags: ["时政", "权威", "新闻"],
    visits: 98200,
    addedAt: "2026-09-28",
    logoText: "人",
    tone: "primary",
    featured: true,
  },
  {
    id: "xinhua",
    name: "新华网",
    url: "https://www.news.cn",
    description: "国家通讯社旗下新闻网站，提供全球资讯与深度评论。",
    detail: "新华网依托国家通讯社的采编资源，提供覆盖全球的新闻资讯与深度评论。频道设置清晰，视频与图解内容丰富，是获取权威信息的重要渠道。适合需要追踪政策动态与宏观大势的用户。",
    categoryId: "新闻资讯",
    subCategory: "综合新闻",
    tags: ["资讯", "通讯社", "全球"],
    visits: 87600,
    addedAt: "2026-09-25",
    logoText: "新",
    tone: "primary",
    featured: false,
  },
  {
    id: "cctv",
    name: "央视网",
    url: "https://www.cctv.com",
    description: "中央广播电视总台官方网站，新闻视频与节目回看一站获取。",
    detail: "央视网是中央广播电视总台的官方网络平台，提供新闻直播、王牌节目回看与短视频内容。视频资源丰富、画质清晰，适合习惯通过视频了解新闻的用户。首页可直达各电视频道栏目。",
    categoryId: "新闻资讯",
    subCategory: "综合新闻",
    tags: ["视频新闻", "直播", "电视"],
    visits: 76300,
    addedAt: "2026-09-20",
    logoText: "央",
    tone: "secondary",
    featured: false,
  },
  {
    id: "thepaper",
    name: "澎湃新闻",
    url: "https://www.thepaper.cn",
    description: "专注时政与思想的媒体平台，深度报道与独家调查见长。",
    detail: "澎湃新闻以时政与社会议题报道著称，深度调查与独家内容质量较高。页面结构清晰，专题策划丰富，适合对新闻深度有要求的读者。建议收藏其思想、时事等特色栏目。",
    categoryId: "新闻资讯",
    subCategory: "综合新闻",
    tags: ["深度报道", "时政", "调查"],
    visits: 54100,
    addedAt: "2026-09-12",
    logoText: "澎",
    tone: "primary",
    featured: false,
  },

  // 电商购物
  {
    id: "taobao",
    name: "淘宝",
    url: "https://www.taobao.com",
    description: "综合性网络购物平台，商品种类齐全，适合多样化的购物需求。",
    detail: "淘宝是国内知名的综合性电商平台，覆盖服饰、家居、数码等海量商品。平台店铺众多、比价方便，配合丰富的促销活动适合日常购物。建议结合销量与评价综合判断，享受更安心的购物体验。",
    categoryId: "电商购物",
    subCategory: "综合电商",
    tags: ["购物", "综合电商", "比价"],
    visits: 152300,
    addedAt: "2026-09-30",
    logoText: "淘",
    tone: "accent",
    featured: true,
  },
  {
    id: "jd",
    name: "京东",
    url: "https://www.jd.com",
    description: "以自营和物流时效见长的综合电商，数码家电购物首选。",
    detail: "京东以自营商品与高效物流著称，3C 数码、家电品类体验突出。商品信息规范、售后体系完善，适合追求配送速度与品质保障的用户。大促期间价格优势明显，可重点关注。",
    categoryId: "电商购物",
    subCategory: "综合电商",
    tags: ["自营", "数码", "物流"],
    visits: 138900,
    addedAt: "2026-09-27",
    logoText: "京",
    tone: "accent",
    featured: false,
  },
  {
    id: "pinduoduo",
    name: "拼多多",
    url: "https://www.pinduoduo.com",
    description: "主打拼团与高性价比的综合购物平台，日用百货很划算。",
    detail: "拼多多通过拼团模式提供高性价比商品，日用百货、农产品品类优势明显。适合对价格敏感、愿意与亲友拼单的用户。下单前建议查看店铺评分与真实评价，选购更放心。",
    categoryId: "电商购物",
    subCategory: "综合电商",
    tags: ["拼团", "性价比", "百货"],
    visits: 96400,
    addedAt: "2026-09-18",
    logoText: "拼",
    tone: "accent",
    featured: false,
  },
  {
    id: "vip",
    name: "唯品会",
    url: "https://www.vip.com",
    description: "专注品牌特卖的电商平台，服饰鞋包折扣力度较大。",
    detail: "唯品会专注品牌特卖，服饰鞋包、美妆个护等品类折扣力度较大。正品保障与限时特卖是其主要特色，适合追求品牌又希望省钱的用户。关注品牌日活动可获取更优价格。",
    categoryId: "电商购物",
    subCategory: "品牌特卖",
    tags: ["品牌特卖", "服饰", "折扣"],
    visits: 43200,
    addedAt: "2026-09-08",
    logoText: "唯",
    tone: "secondary",
    featured: false,
  },

  // 社交娱乐
  {
    id: "weibo",
    name: "微博",
    url: "https://weibo.com",
    description: "开放式社交媒体平台，热点话题与实时资讯快速传播。",
    detail: "微博是开放式社交媒体平台，热门话题与突发事件在这里快速发酵。关注感兴趣的人和话题即可实时获取资讯，适合喜欢参与公共讨论、追踪热点的用户。",
    categoryId: "社交娱乐",
    subCategory: "社交平台",
    tags: ["热点", "社交", "话题"],
    visits: 121500,
    addedAt: "2026-09-29",
    logoText: "微",
    tone: "accent",
    featured: true,
  },
  {
    id: "zhihu",
    name: "知乎",
    url: "https://www.zhihu.com",
    description: "中文问答社区，汇聚专业回答与经验分享。",
    detail: "知乎是中文互联网知名的问答社区，涵盖科技、职场、生活等众多话题。优质回答与专栏内容信息密度较高，适合带着具体问题寻找专业解答。关注擅长领域可获得持续优质内容推荐。",
    categoryId: "社交娱乐",
    subCategory: "兴趣社区",
    tags: ["问答", "知识", "社区"],
    visits: 89700,
    addedAt: "2026-09-22",
    logoText: "知",
    tone: "primary",
    featured: false,
  },
  {
    id: "douban",
    name: "豆瓣",
    url: "https://www.douban.com",
    description: "书影音评分与兴趣小组社区，文艺爱好者的聚集地。",
    detail: "豆瓣以书影音评分体系著称，评分参考价值高，兴趣小组讨论氛围浓厚。适合在观影、读书、听歌前先看看评分与短评。小组与同城活动可以帮助找到志同道合的朋友。",
    categoryId: "社交娱乐",
    subCategory: "兴趣社区",
    tags: ["书影音", "评分", "小组"],
    visits: 63200,
    addedAt: "2026-09-15",
    logoText: "豆",
    tone: "secondary",
    featured: false,
  },
  {
    id: "xiaohongshu",
    name: "小红书",
    url: "https://www.xiaohongshu.com",
    description: "生活方式分享社区，种草测评与经验笔记丰富。",
    detail: "小红书是生活方式分享社区，美妆、穿搭、旅行、家居等领域笔记丰富。真实体验与攻略内容对消费决策有较高参考价值。搜索具体需求即可快速找到实用笔记。",
    categoryId: "社交娱乐",
    subCategory: "内容分享",
    tags: ["种草", "笔记", "生活"],
    visits: 108700,
    addedAt: "2026-09-24",
    logoText: "小",
    tone: "accent",
    featured: false,
  },

  // 教育学习
  {
    id: "icourse163",
    name: "中国大学MOOC",
    url: "https://www.icourse163.org",
    description: "汇集国内高校优质慕课，支持系统化在线学习。",
    detail: "中国大学MOOC汇聚国内众多高校的优质课程，覆盖计算机、经管、人文等学科。支持视频学习、随堂测验与结课证书，适合希望系统学习专业知识的用户。按学科分类挑选课程效率更高。",
    categoryId: "教育学习",
    subCategory: "在线课程",
    tags: ["慕课", "高校", "系统学习"],
    visits: 47600,
    addedAt: "2026-09-19",
    logoText: "慕",
    tone: "secondary",
    featured: false,
  },
  {
    id: "open163",
    name: "网易公开课",
    url: "https://open.163.com",
    description: "国内外名校公开课与 TED 演讲的中文字幕平台。",
    detail: "网易公开课收录国内外名校公开课、纪录片与 TED 演讲，多数配有中文字幕。内容偏通识与人文，适合碎片化时间拓展视野。按专题浏览可形成较完整的学习脉络。",
    categoryId: "教育学习",
    subCategory: "公开课",
    tags: ["公开课", "TED", "通识"],
    visits: 38900,
    addedAt: "2026-09-11",
    logoText: "网",
    tone: "primary",
    featured: false,
  },
  {
    id: "keqq",
    name: "腾讯课堂",
    url: "https://ke.qq.com",
    description: "覆盖职业技能与兴趣培训的在线学习平台。",
    detail: "腾讯课堂提供职业技能、考试考证与兴趣爱好等在线课程，直播与录播形式兼备。适合希望提升职场技能或备考的用户。选购前可先试听，关注课程评价再做决定。",
    categoryId: "教育学习",
    subCategory: "在线课程",
    tags: ["职业技能", "直播课", "考证"],
    visits: 41200,
    addedAt: "2026-09-06",
    logoText: "课",
    tone: "accent",
    featured: false,
  },
  {
    id: "xueersi",
    name: "学而思网校",
    url: "https://www.xueersi.com",
    description: "面向中小学的在线课堂，课程体系较为完整。",
    detail: "学而思网校面向中小学阶段提供学科类在线课程，课程体系与配套练习较完整。适合有系统学习需求的学生与家长了解与选择，建议结合孩子实际情况挑选合适的班型。",
    categoryId: "教育学习",
    subCategory: "考试学习",
    tags: ["中小学", "网校", "辅导"],
    visits: 29800,
    addedAt: "2026-08-30",
    logoText: "学",
    tone: "secondary",
    featured: false,
  },

  // 工具软件
  {
    id: "baidupan",
    name: "百度网盘",
    url: "https://pan.baidu.com",
    description: "常用的云存储与文件分享服务，支持多端同步。",
    detail: "百度网盘提供大容量云存储与文件分享能力，支持电脑与移动端同步。适合备份资料、传输大文件与在线预览文档。合理规划文件夹结构可让资源管理更高效。",
    categoryId: "工具软件",
    subCategory: "云存储",
    tags: ["云盘", "存储", "分享"],
    visits: 143600,
    addedAt: "2026-09-26",
    logoText: "盘",
    tone: "primary",
    featured: true,
  },
  {
    id: "shimo",
    name: "石墨文档",
    url: "https://shimo.im",
    description: "支持多人协作的在线文档与表格工具。",
    detail: "石墨文档是一款在线协同办公工具，支持文档、表格与幻灯片多人实时编辑。适合团队协作整理资料与制定计划，评论与历史版本功能便于沟通和追溯。",
    categoryId: "工具软件",
    subCategory: "效率办公",
    tags: ["协同", "文档", "办公"],
    visits: 36700,
    addedAt: "2026-09-14",
    logoText: "石",
    tone: "secondary",
    featured: false,
  },
  {
    id: "iflyrec",
    name: "讯飞听见",
    url: "https://www.iflyrec.com",
    description: "语音转文字与会议纪要工具，识别准确率较高。",
    detail: "讯飞听见提供语音转文字、会议记录整理与字幕制作等能力，中文识别准确率较高。适合整理访谈、会议录音与课程笔记，能显著提升记录效率。",
    categoryId: "工具软件",
    subCategory: "在线工具",
    tags: ["语音转文字", "会议", "效率"],
    visits: 33400,
    addedAt: "2026-09-09",
    logoText: "讯",
    tone: "primary",
    featured: false,
  },
  {
    id: "clim",
    name: "草料二维码",
    url: "https://cli.im",
    description: "在线二维码生成与管理工具，支持多场景应用。",
    detail: "草料二维码是常用的二维码生成与管理平台，支持文本、网址、文件等多种内容类型。可对二维码进行美化与数据统计，适合活动推广、物料制作等场景。",
    categoryId: "工具软件",
    subCategory: "在线工具",
    tags: ["二维码", "生成器", "统计"],
    visits: 28900,
    addedAt: "2026-08-28",
    logoText: "草",
    tone: "accent",
    featured: false,
  },

  // 金融理财
  {
    id: "eastmoney",
    name: "东方财富网",
    url: "https://www.eastmoney.com",
    description: "综合财经门户，行情数据与资讯信息丰富。",
    detail: "东方财富网提供股票行情、基金数据、财经资讯与社区讨论，信息维度全面。适合关注资本市场动态、需要查询行情数据的用户。使用前请理性看待行情波动。",
    categoryId: "金融理财",
    subCategory: "股票行情",
    tags: ["财经", "行情", "基金"],
    visits: 71300,
    addedAt: "2026-09-23",
    logoText: "东",
    tone: "accent",
    featured: false,
  },
  {
    id: "jqka",
    name: "同花顺",
    url: "https://www.10jqka.com.cn",
    description: "行情软件与财经资讯平台，数据查询便捷。",
    detail: "同花顺提供实时行情、财务数据与财经资讯，配套软件功能丰富。适合需要多维度查看行情与数据的用户，自选股与预警功能便于日常跟踪。",
    categoryId: "金融理财",
    subCategory: "股票行情",
    tags: ["行情", "数据", "自选股"],
    visits: 66800,
    addedAt: "2026-09-16",
    logoText: "同",
    tone: "primary",
    featured: false,
  },
  {
    id: "cmbchina",
    name: "招商银行",
    url: "https://www.cmbchina.com",
    description: "网上银行服务入口，支持账户查询与线上业务办理。",
    detail: "招商银行官网提供个人与企业的网上银行服务入口，支持账户查询、转账与理财业务办理。页面功能分区清晰，适合需要在线处理银行业务的用户。请注意保护账户与密码安全。",
    categoryId: "金融理财",
    subCategory: "银行服务",
    tags: ["网上银行", "账户", "理财"],
    visits: 45800,
    addedAt: "2026-09-05",
    logoText: "招",
    tone: "secondary",
    featured: false,
  },
  {
    id: "alipay",
    name: "支付宝",
    url: "https://www.alipay.com",
    description: "常用的在线支付与生活缴费平台。",
    detail: "支付宝提供在线支付、缴费与生活服务入口，覆盖消费与便民场景。支持多种生活缴费与小程序服务，日常使用便捷。请通过官方渠道下载与访问，注意资金安全。",
    categoryId: "金融理财",
    subCategory: "支付理财",
    tags: ["支付", "缴费", "生活服务"],
    visits: 118900,
    addedAt: "2026-09-21",
    logoText: "支",
    tone: "primary",
    featured: true,
  },

  // 生活服务
  {
    id: "meituan",
    name: "美团",
    url: "https://www.meituan.com",
    description: "本地生活服务平台，外卖、酒店与到店消费一站搞定。",
    detail: "美团是本地生活服务平台，涵盖外卖、酒店预订、到店餐饮与休闲娱乐等场景。优惠信息丰富、覆盖城市广，适合日常消费与出行安排。多方比较套餐可找到更合适的方案。",
    categoryId: "生活服务",
    subCategory: "本地生活",
    tags: ["外卖", "酒店", "到店"],
    visits: 134200,
    addedAt: "2026-09-30",
    logoText: "美",
    tone: "accent",
    featured: true,
  },
  {
    id: "dianping",
    name: "大众点评",
    url: "https://www.dianping.com",
    description: "本地商户点评与推荐平台，吃喝玩乐参考价值高。",
    detail: "大众点评汇集本地餐饮、休闲娱乐与生活服务的真实评价与图片，排行榜单参考性强。适合外出就餐或周末安排前做功课。结合评分与最新评论筛选更靠谱。",
    categoryId: "生活服务",
    subCategory: "本地生活",
    tags: ["点评", "美食", "榜单"],
    visits: 78600,
    addedAt: "2026-09-17",
    logoText: "评",
    tone: "accent",
    featured: false,
  },
  {
    id: "58",
    name: "58同城",
    url: "https://www.58.com",
    description: "分类信息平台，租房、二手与生活服务信息集中。",
    detail: "58同城是综合性分类信息平台，覆盖租房、二手交易、家政维修等本地信息。信息量大、更新频繁，适合查找同城生活资源。建议核实发布者信息，注意防范交易风险。",
    categoryId: "生活服务",
    subCategory: "分类信息",
    tags: ["分类信息", "租房", "二手"],
    visits: 62900,
    addedAt: "2026-09-10",
    logoText: "58",
    tone: "primary",
    featured: false,
  },
  {
    id: "weather",
    name: "中国天气网",
    url: "https://www.weather.com.cn",
    description: "官方气象服务网站，天气预报与预警信息准确。",
    detail: "中国天气网提供全国城市天气预报、气象预警与生活指数，数据来源权威。适合出行前查看天气与预警信息，合理安排行程。可关注所在城市的逐小时预报。",
    categoryId: "生活服务",
    subCategory: "实用查询",
    tags: ["天气", "预警", "出行"],
    visits: 54700,
    addedAt: "2026-09-03",
    logoText: "天",
    tone: "secondary",
    featured: false,
  },

  // 视频音乐
  {
    id: "bilibili",
    name: "哔哩哔哩",
    url: "https://www.bilibili.com",
    description: "年轻人聚集的视频社区，知识、娱乐与学习内容兼具。",
    detail: "哔哩哔哩是综合性视频社区，涵盖知识科普、影视剪辑、游戏与学习教程等丰富内容。弹幕互动氛围活跃，适合娱乐与学习兼顾。关注分区与 UP 主可持续获取优质内容。",
    categoryId: "视频音乐",
    subCategory: "视频平台",
    tags: ["视频", "社区", "知识"],
    visits: 149800,
    addedAt: "2026-09-29",
    logoText: "B",
    tone: "secondary",
    featured: true,
  },
  {
    id: "iqiyi",
    name: "爱奇艺",
    url: "https://www.iqiyi.com",
    description: "综合视频平台，影视剧与综艺节目资源丰富。",
    detail: "爱奇艺提供影视剧、综艺、动漫与纪录片等内容，自制剧与独播资源较多。适合追剧与休闲观看，会员可享更高画质与提前观看权益。可结合评分榜单挑选内容。",
    categoryId: "视频音乐",
    subCategory: "视频平台",
    tags: ["影视", "综艺", "会员"],
    visits: 97800,
    addedAt: "2026-09-22",
    logoText: "爱",
    tone: "secondary",
    featured: false,
  },
  {
    id: "qqvideo",
    name: "腾讯视频",
    url: "https://v.qq.com",
    description: "主流在线视频平台，剧集与体育赛事内容多样。",
    detail: "腾讯视频覆盖剧集、电影、综艺与体育赛事等内容，独家版权资源丰富。播放体验稳定、多端互通，适合家庭娱乐与追剧。关注片单可快速发现值得一看的内容。",
    categoryId: "视频音乐",
    subCategory: "视频平台",
    tags: ["剧集", "体育", "综艺"],
    visits: 88400,
    addedAt: "2026-09-13",
    logoText: "腾",
    tone: "primary",
    featured: false,
  },
  {
    id: "netease163",
    name: "网易云音乐",
    url: "https://music.163.com",
    description: "音乐播放与歌单分享平台，评论区氛围独特。",
    detail: "网易云音乐提供在线音乐播放、个性化歌单与乐评社区，推荐算法较贴合口味。适合发现新歌与音乐人作品，乐评区常能读到有趣的听歌故事。",
    categoryId: "视频音乐",
    subCategory: "音乐电台",
    tags: ["音乐", "歌单", "电台"],
    visits: 81200,
    addedAt: "2026-09-07",
    logoText: "云",
    tone: "accent",
    featured: false,
  },

  // 科技数码
  {
    id: "ithome",
    name: "IT之家",
    url: "https://www.ithome.com",
    description: "数码科技资讯站点，更新速度快、资讯密度高。",
    detail: "IT之家专注科技与数码资讯，内容更新速度快，涵盖新品发布、行业动态与软件更新。适合科技爱好者每天快速浏览动态。评论区讨论活跃，可作为观点补充参考。",
    categoryId: "科技数码",
    subCategory: "数码资讯",
    tags: ["科技", "资讯", "数码"],
    visits: 57300,
    addedAt: "2026-09-24",
    logoText: "IT",
    tone: "primary",
    featured: false,
  },
  {
    id: "zol",
    name: "中关村在线",
    url: "https://www.zol.com.cn",
    description: "数码产品报价与评测导购平台，参数对比方便。",
    detail: "中关村在线提供数码产品报价、参数对比与专业评测，产品库信息全面。适合购机前做功课，对比不同型号的参数与价格。经销商报价可作参考，注意甄别商家资质。",
    categoryId: "科技数码",
    subCategory: "评测导购",
    tags: ["报价", "评测", "导购"],
    visits: 49800,
    addedAt: "2026-09-18",
    logoText: "Z",
    tone: "accent",
    featured: false,
  },
  {
    id: "pconline",
    name: "太平洋电脑网",
    url: "https://www.pconline.com.cn",
    description: "IT 产品资讯与评测门户，选购参考信息丰富。",
    detail: "太平洋电脑网提供电脑数码产品的资讯、评测与导购内容，产品库与经销商资源较全。适合在选购前了解产品优缺点与市场行情，结合多方评测做决策更稳妥。",
    categoryId: "科技数码",
    subCategory: "评测导购",
    tags: ["电脑", "评测", "行情"],
    visits: 35600,
    addedAt: "2026-09-04",
    logoText: "太",
    tone: "secondary",
    featured: false,
  },
  {
    id: "sspai",
    name: "少数派",
    url: "https://sspai.com",
    description: "效率工具与数字生活内容平台，实用性好文集中。",
    detail: "少数派专注效率软件、硬件与数字生活方式，教程与评测内容质量较高。适合希望用工具提升效率的读者，许多文章配有可直接上手的方法与清单。",
    categoryId: "科技数码",
    subCategory: "行业观察",
    tags: ["效率", "工具", "数字生活"],
    visits: 42300,
    addedAt: "2026-09-11",
    logoText: "少",
    tone: "primary",
    featured: false,
  },

  // 招聘求职
  {
    id: "zhaopin",
    name: "智联招聘",
    url: "https://www.zhaopin.com",
    description: "综合性招聘平台，职位覆盖行业与城市广泛。",
    detail: "智联招聘是综合性招聘平台，职位覆盖多个行业与城市，企业类型多样。支持简历投递与职位订阅，适合不同阶段的求职者。完善简历并设置求职意向可提升匹配效率。",
    categoryId: "招聘求职",
    subCategory: "综合招聘",
    tags: ["招聘", "简历", "求职"],
    visits: 61300,
    addedAt: "2026-09-20",
    logoText: "智",
    tone: "primary",
    featured: false,
  },
  {
    id: "51job",
    name: "前程无忧",
    url: "https://www.51job.com",
    description: "老牌综合招聘网站，企业与职位信息量较大。",
    detail: "前程无忧是资深的综合招聘网站，企业与职位信息量较大，覆盖传统与新兴行业。适合系统性求职与行业调研，可通过关键词与条件筛选快速定位岗位。",
    categoryId: "招聘求职",
    subCategory: "综合招聘",
    tags: ["招聘", "企业", "职位"],
    visits: 52600,
    addedAt: "2026-09-12",
    logoText: "前",
    tone: "accent",
    featured: false,
  },
  {
    id: "zhipin",
    name: "BOSS直聘",
    url: "https://www.zhipin.com",
    description: "直聊模式的招聘平台，沟通效率较高。",
    detail: "BOSS直聘采用与招聘方直接沟通的模式，减少中间环节，沟通效率较高。适合希望快速了解岗位详情与推进面试的求职者。沟通前建议准备好简历与自我介绍要点。",
    categoryId: "招聘求职",
    subCategory: "互联网招聘",
    tags: ["直聊", "互联网", "面试"],
    visits: 71900,
    addedAt: "2026-09-26",
    logoText: "B",
    tone: "primary",
    featured: true,
  },
  {
    id: "lagou",
    name: "拉勾网",
    url: "https://www.lagou.com",
    description: "聚焦互联网行业的招聘平台，技术岗位集中。",
    detail: "拉勾网聚焦互联网行业招聘，技术、产品、运营等岗位集中，薪资信息相对透明。适合互联网从业者寻找机会，可结合岗位要求提前准备作品与项目经历。",
    categoryId: "招聘求职",
    subCategory: "互联网招聘",
    tags: ["互联网", "技术岗", "薪资"],
    visits: 39800,
    addedAt: "2026-09-09",
    logoText: "拉",
    tone: "secondary",
    featured: false,
  },

  // 旅游出行
  {
    id: "ctrip",
    name: "携程旅行",
    url: "https://www.ctrip.com",
    description: "一站式旅行预订平台，机票酒店与度假产品齐全。",
    detail: "携程旅行提供机票、酒店、火车票与度假产品的在线预订，资源覆盖国内外。行程管理与客服体系较完善，适合规划自由行与跟团游。提前预订通常能获得更优价格。",
    categoryId: "旅游出行",
    subCategory: "机票酒店",
    tags: ["机票", "酒店", "度假"],
    visits: 92700,
    addedAt: "2026-09-27",
    logoText: "携",
    tone: "primary",
    featured: true,
  },
  {
    id: "qunar",
    name: "去哪儿旅行",
    url: "https://www.qunar.com",
    description: "旅游搜索比价平台，机票酒店价格对比方便。",
    detail: "去哪儿旅行主打旅游产品搜索与比价，机票、酒店的价格对比直观。适合出行前多方比价、寻找优惠。下单前留意退改规则与附加费用，避免不必要的支出。",
    categoryId: "旅游出行",
    subCategory: "机票酒店",
    tags: ["比价", "机票", "酒店"],
    visits: 63500,
    addedAt: "2026-09-17",
    logoText: "去",
    tone: "accent",
    featured: false,
  },
  {
    id: "mafengwo",
    name: "马蜂窝",
    url: "https://www.mafengwo.cn",
    description: "旅游攻略与游记社区，行程规划参考价值高。",
    detail: "马蜂窝以旅游攻略与游记内容见长，覆盖国内外众多目的地。攻略与问答内容详实，适合出发前了解路线、交通与注意事项。结合他人行程可快速搭好自己的路线。",
    categoryId: "旅游出行",
    subCategory: "攻略社区",
    tags: ["攻略", "游记", "目的地"],
    visits: 48600,
    addedAt: "2026-09-08",
    logoText: "马",
    tone: "secondary",
    featured: false,
  },
  {
    id: "12306",
    name: "12306",
    url: "https://www.12306.cn",
    description: "官方铁路客票服务网站，列车查询与购票可靠。",
    detail: "12306 是铁路官方客票服务平台，提供余票查询、购票与订单管理功能，信息来源权威。适合火车出行的行程安排与购票。节假日建议提前关注放票时间，及时下单。",
    categoryId: "旅游出行",
    subCategory: "交通出行",
    tags: ["火车票", "官方", "行程"],
    visits: 84100,
    addedAt: "2026-09-19",
    logoText: "铁",
    tone: "primary",
    featured: false,
  },

  // 编程开发
  {
    id: "github",
    name: "GitHub",
    url: "https://github.com",
    description: "全球最大的代码托管与开源协作平台。",
    detail: "GitHub 是全球知名的代码托管平台，汇聚海量开源项目与开发者协作生态。适合学习优秀项目源码、管理自己的代码仓库与参与开源贡献。善用搜索与优秀项目榜单能快速提升技能。",
    categoryId: "编程开发",
    subCategory: "代码托管",
    tags: ["开源", "代码", "协作"],
    visits: 113400,
    addedAt: "2026-09-28",
    logoText: "G",
    tone: "primary",
    featured: true,
  },
  {
    id: "juejin",
    name: "稀土掘金",
    url: "https://juejin.cn",
    description: "面向开发者的技术内容社区，前后端干货集中。",
    detail: "稀土掘金是开发者技术内容社区，涵盖前端、后端、人工智能等方向。优质技术文章与实战经验丰富，适合开发者日常充电与拓宽技术视野。关注标签可获得个性化推荐。",
    categoryId: "编程开发",
    subCategory: "技术社区",
    tags: ["技术", "前端", "社区"],
    visits: 56700,
    addedAt: "2026-09-21",
    logoText: "掘",
    tone: "accent",
    featured: false,
  },
  {
    id: "csdn",
    name: "CSDN",
    url: "https://www.csdn.net",
    description: "中文技术社区与博客平台，问题排查资料丰富。",
    detail: "CSDN 是中文技术社区与博客平台，技术问题排查资料丰富、覆盖语言广泛。遇到具体报错时往往能检索到相关记录，适合开发者查漏补缺。阅读时注意甄别内容时效性。",
    categoryId: "编程开发",
    subCategory: "技术社区",
    tags: ["博客", "问答", "排错"],
    visits: 79400,
    addedAt: "2026-09-14",
    logoText: "C",
    tone: "primary",
    featured: false,
  },
  {
    id: "oschina",
    name: "开源中国",
    url: "https://www.oschina.net",
    description: "中文开源技术社区，资讯与开源项目资源丰富。",
    detail: "开源中国是中文开源技术社区，提供开源项目发现、技术资讯与博客内容。适合了解国内开源项目动态与寻找可复用的工具。项目库可按语言与分类筛选，查阅效率较高。",
    categoryId: "编程开发",
    subCategory: "开源项目",
    tags: ["开源", "项目", "资讯"],
    visits: 37200,
    addedAt: "2026-09-02",
    logoText: "开",
    tone: "secondary",
    featured: false,
  },
];